export default {
  name: 'Test',
  date() {
    return {
      a: 'hh'
    };
  },
  render() {
    return <div style="color: red">
      hello world
    </div>;
  }
};



// WEBPACK FOOTER //
// ./app/pages/jsx/index.js